import { DateTime } from 'luxon';

// Format range date for filtering / exporting
export const formatDateFilter = (date) => {
  if (!date) {
    return null;
  }

  return DateTime.fromJSDate(date).toISODate();
};

// Format filter date range input
export const formatDateRange = (range) => {
  if (!range.start && !range.end) {
    return 'Filter by date';
  }

  if (range.start && !range.end) {
    return `Starting ${range.start.toLocaleString().split(',')[0]}`;
  }

  if (range.end && !range.start) {
    return `Ending ${range.start.toLocaleString().split(',')[0]}`;
  }

  return `${range.start.toLocaleString().split(',')[0]} - ${range.end.toLocaleString().split(',')[0]
    }`;
};

// Capitalize string
export const capitalize = (value) => {
  let capitalizeVal = value;

  if (!capitalizeVal) {
    return '';
  }

  capitalizeVal = capitalizeVal.toString();

  return capitalizeVal.charAt(0).toUpperCase() + capitalizeVal.slice(1);
};

// Generates a fully encoded and resized url for a given image object
// See resizing documentation: https://github.com/lovell/sharp/blob/master/docs/api-resize.md
export const awsImageUrl = (imageData, width, height, fit = 'inside') => {
  const imageRequest = JSON.stringify({
    bucket: imageData.bucket,
    key: imageData.path,
    edits: {
      resize: {
        width,
        height,
        fit,
      },
    },
  });

  return `${imageData.cloudfront_url}/${btoa(imageRequest)}`;
};
